(() => {
  const SELECTOR = '.bd-offer-reveal, .bd-offer-flow';

  function markVisible(element) {
    element.classList.add('is-visible');
  }

  function getTargets(root) {
    return Array.from(root.querySelectorAll(SELECTOR)).filter((element) => {
      if (element.dataset.bdOfferObserved === 'true') {
        return false;
      }

      element.dataset.bdOfferObserved = 'true';
      return true;
    });
  }

  function init(root = document) {
    const targets = getTargets(root);
    if (!targets.length) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(markVisible);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        markVisible(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.12
    });

    targets.forEach((target) => observer.observe(target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
